import type { SubjectLineCondition as SubjectLineConditionType } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";

export const SubjectLineCondition = memo(function SubjectLineCondition({
  condition,
  onChange,
  editableFields,
}: {
  condition: SubjectLineConditionType;
  onChange: (updated: SubjectLineConditionType) => void;
  editableFields?: ReadonlySet<string>;
}) {
  const [inputValue, setInputValue] = useState("");
  const isEditable = (f: string) =>
    editableFields === undefined || editableFields.has(f);
  const queryStringsEditable = isEditable("queryStrings");
  const caseSensitiveEditable = isEditable("caseSensitive");

  return (
    <Flex dir="column" gap="lg" w="full">
      <Flex
        style={
          queryStringsEditable
            ? undefined
            : { pointerEvents: "none", opacity: 0.6 }
        }
      >
        <RedoTagInputField
          delimiters={["newline"]}
          inputValue={inputValue}
          label="Subject text to match"
          placeholder="Enter subject text to match"
          setInputValue={setInputValue}
          setTags={(queryStrings) => {
            if (!queryStringsEditable) return;
            const uniqueStrings = Array.from(new Set(queryStrings));
            onChange({ ...condition, queryStrings: uniqueStrings });
          }}
          state="default"
          tags={(condition.queryStrings || []).map((text) => ({ text }))}
        />
      </Flex>
      <RedoCheckbox
        disabled={!caseSensitiveEditable}
        label="Case sensitive"
        setValue={(v) => {
          if (!caseSensitiveEditable) return;
          onChange({ ...condition, caseSensitive: v === true });
        }}
        size="sm"
        value={condition.caseSensitive || false}
      />
    </Flex>
  );
});
